//------ PAGE HEADER SLIDER STARTS ------//

jQuery(function(){ //equivalent of ready in jQ 3.0

    function handleSlideChange(e) {
        var $container = jQuery(e.target);
        var current_slide = e.detail.currentSlide - 1;
        var $nav = $container.find('.page-header-slider__nav--mobile');
        var $active_dot = $nav.find('.page-header-slider__dot:eq('+ current_slide +')');

        jQuery('.page-header-slider__dot').removeClass('page-header-slider__dot--active');
        $container.find('.page-header-slider__current-slide').html(e.detail.currentSlide);
        $active_dot.addClass('page-header-slider__dot--active');
    }

    /*function handleSlideChangeRewind(e) {
        var $container = jQuery(e.target);
        var current_slide = e.detail.currentSlide;
        var $nav = $container.find('.page-header-slider__nav--mobile');
        var $active_dot = $nav.find('.page-header-slider__dot:eq(' + current_slide + ')');

        jQuery('.page-header-slider__dot').removeClass('page-header-slider__dot--active');
        $container.find('.page-header-slider__current-slide').html(e.detail.currentSlide + 1);
        $active_dot.addClass('page-header-slider__dot--active');
    }*/
    // ghost function ^^

    function sliderAriaHidden() {
        for (var index = 0; index < slides.length; index++) {
            var slide_aria_hidden = slides[index];

            if (slide_aria_hidden.classList.contains('active')) {
                slide_aria_hidden.setAttribute("aria-hidden", "false");
                slide_aria_hidden.setAttribute("tabindex", "0");
            } else {
                slide_aria_hidden.setAttribute("aria-hidden", "true");
                slide_aria_hidden.setAttribute("tabindex", "-1");
            };
        };
    };

    function sliderAriaSelectedDots() {
        for (var index = 0; index < slide_dots.length; index++) {
            var slide_dot_aria = slide_dots[index];

            if (slide_dot_aria.classList.contains('page-header-slider__dot--active')) {
                slide_dot_aria.setAttribute("aria-selected", "true");
            } else {
                slide_dot_aria.setAttribute("aria-selected", "false");
            };
        };
    };

    function changeActive () {
        if (jQuery(".page-header-slider__slide").hasClass("active")) {
            //console.log("page resize triggered - PHS");
            jQuery(".page-header-slider__slide").removeClass("active");
        }
    }

    //=============================================
    // * NCC-640 Page Header Slider <START

    function initializePageHeaderSlider() {
        //console.log("PH slider initialized!");

        // ? check for page-header-slider
        if(page_slider) {
            // ? Initialize slider and options
            var s = lory(page_slider, {
                // rewind: 1,
                infinite: 1,
                // ! Uncompiled https://github.com/loryjs/lory lory.js line 587 reset() commented out to fix library issues delt with for ticket NCC-640. Do not confuse with the file in vendor/lory which is compilied but not uglified. Below are links with descriptions related to the unresolved issue in the lory library:
                // ! https://github.com/loryjs/lory/issues/237
                // ! https://github.com/loryjs/lory/pull/401
                classNameFrame: 'page-header-slider__frame',
                classNameSlideContainer: 'page-header-slider__slides',
                classNamePrevCtrl: 'page-header-slider__prev',
                classNameNextCtrl: 'page-header-slider__next'
            });

            page_slider.addEventListener('after.lory.slide', handleSlideChange);
        }

        // ? mobile slider dots
        jQuery('body').on('click', '.page-header-slider__dot', function(e){
            s.slideTo(jQuery(this).data('slide'));
            jQuery(page_slider).find('.page-header-slider__dot').removeClass('page-header-slider__dot--active');
            jQuery(this).addClass('page-header-slider__dot--active');

            sliderAriaHidden();
            sliderAriaSelectedDots();
            return false;
        });
    }

    // ? show/hide slider nav
    jQuery('body').on('mouseenter', '.page-header-slider__container', function (e) {
        var $this = jQuery(this);
        $this.find('.page-header-slider__nav').addClass('page-header-slider__nav--hover');

    });

    jQuery('body').on('mouseleave', '.page-header-slider__container', function (e) {
        var $this = jQuery(this);
        $this.find('.page-header-slider__nav').removeClass('page-header-slider__nav--hover');

    });

    //=============================================

    // * WCAG-56 AODA fixes
    var slides = document.getElementsByClassName("page-header-slider__slide");
    var slide_arrows = document.getElementsByClassName("slider_arrow");
    var slide_dots = document.getElementsByClassName("page-header-slider__dot");
    var page_slider = document.querySelector('.page-header-slider__container');

    function postInitializePageHeaderSlider() {

        for (var index = 0; index < slide_arrows.length; index++) {
            var SlideArrows = slide_arrows[index];

            SlideArrows.onclick = function () {
                sliderAriaHidden();
                sliderAriaSelectedDots();
            };
        };

        sliderAriaSelectedDots();
        sliderAriaHidden();
    }
    // * end WCAG-56 AODA fixes

    if (jQuery('.page-header-slider__container').length) {
        initializePageHeaderSlider();
        postInitializePageHeaderSlider();
        
        window.addEventListener('resize', changeActive);
    }

});

//------ PAGE HEADER SLIDER ENDS ------//